<template>
  <div>
    <FloatLabel variant="in">
      <label :class="labelClass" :for="id">{{ label }}</label>
      <DatePicker
        v-model="localValue"
        date-format="dd.mm.yy"
        :manual-input="true"
        :input-id="id"
        class="w-full"
        :time-only="timeOnly"
        hour-format="24"
        :min-date="minDate"
        :max-date="maxDate"
        :invalid="invalid"
        :pt="ptConfig"
        :show-button-bar="showButtonBar"
        @clear-click="onClearClick"
      />
    </FloatLabel>
    <div v-if="firstError" class="form-error mt-1">{{ firstError }}</div>
  </div>
</template>

<script>
import DatePicker from 'primevue/datepicker';
import FloatLabel from 'primevue/floatlabel';

export default {
  name: 'FormDateField',
  components: { DatePicker, FloatLabel },
  props: {
    modelValue: { type: [Date, String], default: null },
    id: { type: String, required: true },
    label: { type: String, required: true },
    errors: { type: Array, default: () => [] },
    timeOnly: { type: Boolean, default: false },
    minDate: { type: [Date, String], default: null },
    maxDate: { type: [Date, String], default: null },
    invalid: { type: Boolean, default: false },
    showButtonBar: { type: Boolean, default: true },
    labelClass: { type: String, default: 'form-label' },
  },
  emits: ['update:modelValue'],
  computed: {
    localValue: {
      get() {
        return this.modelValue;
      },
      set(v) {
        this.$emit('update:modelValue', v);
      },
    },
    ptConfig() {
      return this.timeOnly
        ? { pctodaybutton: { root: { class: 'hidden' } } }
        : null;
    },
    firstError() {
      return this.errors && this.errors.length ? this.errors[0] : null;
    },
  },
  methods: {
    onClearClick() {
      this.localValue = null;
    },
  },
};
</script>
